import { MenuItem, SelectProps } from "@mui/material"
import { observer } from "mobx-react-lite"
import { InputLabel, InputWrapper, SelectComponent } from "../input/styled"

type Props = {
  label?: string,
  keys?: string[],
  options: string[],
} & SelectProps<string>

const Select = observer(({ label, keys, options, sx, ...otherProps }: Props) => {

  return (
    <InputWrapper sx={sx}>
      <InputLabel>{ label }</InputLabel>
      <SelectComponent {...otherProps as any}>
        { options.map((str, index: number) => (
          <MenuItem value={keys? keys[index]: str} key={index}>{ str }</MenuItem>
        ))}
      </SelectComponent>
    </InputWrapper>
  )
})

export default Select